import styled from '@emotion/styled'
import { colors } from 'ic-snacks'
import FlexRow from 'legacy/components/FlexRow'
import Link from 'legacy/components/Link'

// TODO: turn this into an image when we're ready
export const TileHeader = styled.div`
  box-sizing: border-box;
  flex-grow: 1;
  display: flex;
  justify-content: flex-end;
  overflow: hidden;
  border-bottom: 1px solid ${colors.GRAY_93};
`

export const StatusTag = styled.span`
  color: #fff;
  background-color: ${props => props.color || '#fff'};
  position: absolute;
  padding: 4px 16px 4px 8px;
  font-size: 12px;
  top: 16px;
  left: 16px;
  clip-path: polygon(0 0, 100% 0, 85% 100%, 0% 100%);
  border-radius: 3px;
`

export const CardTitle = styled(Link)`
  align-self: stretch;
  flex-grow: 1;
  font-weight: 500;
  color: ${colors.GRAY_20};
  font-size: 16px;
  line-height: 18px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  transition: color 0.25 ease-out;

  &:hover {
    color: ${colors.GREEN_500};
  }
`

export const CardDetails = styled.p<{ empty?: boolean }>`
  font-size: 12px;
  font-weight: 200;
  color: ${props => (props.empty ? colors.GRAY_74 : 'inherit')};
`

export const TileSection = styled(FlexRow)<{
  backgroundColor?: string
  padding?: string
  height?: string
}>`
  flex-shrink: 0;
  background-color: ${props => props.backgroundColor || colors.WHITE};
  padding: ${props => props.padding || '8px 16px'};
  border-bottom: 1px solid ${colors.GRAY_93};
  height: ${props => props.height || '36px'};

  &:last-child {
    border-radius: 0 0 3px 3px;
    border-bottom: 0;
  }
`

export const MiniHeader = styled.span`
  display: block;
  font-size: 10px;
  font-weight: 500;
  color: ${colors.GRAY_74};
  margin-bottom: 6px;
`

export const Divider = styled.div`
  border-right: 1px solid ${colors.GRAY_93};
  height: 42px;
`

export const ScheduleAction = styled.button`
  color: ${props => props.color || colors.GREEN_500};
  position: relative;
  z-index: 1;
  border: none;
  background: none;
  padding: 0;
  font-size: 10px;
  text-transform: uppercase;
  &:focus {
    outline: none;
  }
  cursor: pointer;
  margin-left: 15px;

  &:first-child {
    margin-left: 0;
  }
`

export const ScheduleActionContainer = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
`

export const SchedulePromptText = styled.p`
  color: ${colors.WHITE};
  font-size: 12px;
  font-weight: 200;
`
